<template>
  <article>
    <section class="xbed-sub-title">
      <span>会员管理</span>
    </section>

    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>会员管理</BreadcrumbItem>
        <BreadcrumbItem>会员管理</BreadcrumbItem>
      </Breadcrumb>
    </section>

    <!-- 查询栏 -->
    <Form :model="searchForm" inline class="inquire">
      <FormItem label="身份审核状态" :label-width="100">
        <Select v-model="searchForm.review" class="formWidth">
          <Option value="S00">全部</Option>
          <Option :value="2">2-已验证</Option>
          <Option :value="0">0-未验证</Option>
          <Option :value="4">4-待完成</Option>
          <Option :value="1">1-待审核</Option>
          <Option :value="3">3-审核不通过</Option>
        </Select>
      </FormItem>
      <FormItem label="用户来源" :label-width="80">
        <Select v-model="searchForm.source" class="formWidth">
          <Option value="S00">全部</Option>
          <Option :value="0">0-微信公众号</Option>
          <Option :value="1">1-去呼呼</Option>
          <Option :value="2">2-IOS</Option>
          <Option :value="3">3-Android</Option>
          <Option :value="4">4-OMS</Option>
          <Option :value="5">5-携程</Option>
          <Option :value="6">6-业主会</Option>
          <Option :value="7">7-美团</Option>
          <Option :value="10">10-办理入住时系统注册</Option>
          <Option :value="11">11-活动注册</Option>
          <Option :value="12">12-预订时系统注册</Option>
        </Select>
      </FormItem>
      <FormItem label="姓名" :label-width="60">
        <Input v-model="searchForm.name" :maxlength="20" class="formWidth" placeholder="请输入查询关键字"></Input>
      </FormItem>
      <FormItem label="手机号" :label-width="60">
        <Input v-model="searchForm.phone" class="formWidth" placeholder="请输入查询关键字"></Input>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="queryVipListByKeyword">查询</Button>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="displayAddModal">新增会员</Button>
      </FormItem>
    </Form>
    <!-- 表格信息 -->
    <Table stripe :columns="columnsInfo" :loading="vipList.loading" :data="vipList.data"></Table>
    <!-- 分页 -->
    <Page :total="vipList.count" :page-size="vipList.pageSize" show-sizer @on-change="changePage" @on-page-size-change="changePageSize"
      class="pages"></Page>
    <!-- 修改弹框 -->
    <Modal v-model="editModal.display" ref="editModal" :loading="true" title="修改会员" okText="提交内容" cancel-text="关闭" @on-ok="preEditVip">
      <Form :model="editModal" ref="editForm" :rules="editModal.rules" :label-width="80">
        <FormItem label="ID">
          <Input v-model="editModal.id" disabled></Input>
        </FormItem>
        <FormItem label="姓名" prop="name">
          <Input v-model="editModal.name" :maxlength="20"></Input>
        </FormItem>
        <FormItem label="电子邮箱" prop="email">
          <Input v-model="editModal.email"></Input>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input v-model="editModal.remark" type="textarea" :maxlength="255" :autosize="{minRows: 2,maxRows: 5}"></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- 修改会员状态弹框 -->
    <Modal v-model="editStatusModal.display" title="修改会员状态" :loading="true" ref="editStatusModal" okText="提交内容" cancel-text="关闭" @on-ok="preEditStatusVip">
      <Form :model="editStatusModal" ref="editStatusForm" :label-width="80">
        <FormItem label="姓名">
          <Input v-model="editStatusModal.name" disabled></Input>
        </FormItem>
        <FormItem label="状态">
          <RadioGroup v-model="editStatusModal.status">
            <Radio :label="1">正常</Radio>
            <Radio :label="2">锁定</Radio>
            <Radio :label="3">黑名单</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
    </Modal>
    <!-- 新增会员弹框 -->
    <Modal v-model="addModal.display" title="新增会员" ref="addModal" :loading="true" cancel-text="关闭" @on-ok="preAddVip">
      <Form :model="addModal" ref="addForm" :rules="addModal.rules" :label-width="80">
        <FormItem label="姓名" prop="name">
          <Input v-model="addModal.name" :maxlength="20"></Input>
        </FormItem>
        <FormItem label="手机号" prop="phone">
          <Input v-model="addModal.phone"></Input>
        </FormItem>
        <FormItem label="性别" prop="sex">
          <RadioGroup v-model="addModal.sex">
            <Radio :label="1">男</Radio>
            <Radio :label="0">女</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="电子邮箱" prop="email">
          <Input v-model="addModal.email"></Input>
        </FormItem>
        <FormItem label="主渠道" prop="mainChannel">
          <Select v-model="addModal.mainChannel" transfer>
            <Option v-for="(option, key) in usersSources" :key="key" :value="key">{{`${key} - ${option.name}`}}</Option>
          </Select>
        </FormItem>
        <FormItem label="父渠道" prop="parentChannel">
          <Select v-model="addModal.parentChannel" transfer>
            <Option v-for="(parentChannel, key) in parentChannelList" :key="key" :value="key">{{`${key} - ${parentChannel.name}`}}</Option>
          </Select>
        </FormItem>
        <FormItem label="子渠道" prop="childChannel">
          <Select v-model="addModal.childChannel" transfer>
            <Option v-for="(childChannel,key) in childChannelList" :key="key" :value="key">{{`${key} - ${childChannel.name}`}}</Option>
          </Select>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input v-model="addModal.remark" type="textarea" :maxlength="255" :autosize="{minRows: 2,maxRows: 5}"></Input>
        </FormItem>
      </Form>
    </Modal>
  </article>
</template>

<script>
  import Utils from "@/utils";
  import API from "../../api";
  import moment from "moment";
  import {STORE_KEY} from "../../constants"

  import {
    phoneRegular,
    emailRegular
  } from '../../utils/regular'
  export default {
    created() {
      this.token = Utils.findFromLocalStorage("vue-token");
      this.env = Utils.findFromLocalStorage("env", "dev");
    },
    async mounted() {
      this.$Notice.config({
        top: 200
      });

      this.queryVipList();

      // 新增会员下的来源渠道接口
      const usersSourcesResp = (await API.omsAPI[
        this.env
      ].php.queryUsersSources()).data;

      if (usersSourcesResp.retcode != 1) {
        this.$Notice.error({
          title: "查询用户来源渠道失败"
        });
        return;
      }

      this.usersSources = usersSourcesResp.retdata;
    },
    computed: {
      // 父渠道列表
      parentChannelList() {
        if (!this.addModal.mainChannel ||
          !this.usersSources[this.addModal.mainChannel]
        ) {
          return {};
        }
        this.addModal.parentChannel = Object.keys(this.usersSources[this.addModal.mainChannel].child)[0]
        return this.usersSources[this.addModal.mainChannel].child;
      },
      // 子渠道列表
      childChannelList() {
        if (!this.addModal.parentChannel ||
          !this.usersSources[this.addModal.mainChannel].child[
            this.addModal.parentChannel
          ]
        ) {
          return {};
        }
        this.addModal.childChannel = Object.keys(this.usersSources[this.addModal.mainChannel].child[this.addModal.parentChannel]
          .child)[0]
        return this.usersSources[this.addModal.mainChannel].child[
          this.addModal.parentChannel
        ].child;
      }
    },
    data() {
      return {
        usersSources: {},
        parentChannel: {},
        childChannel: {},
        searchForm: {
          review: 'S00',
          source: 'S00',
          name: '',
          phone: ''
        },
        vipList: {
          page: 1,
          pageSize: 10,
          count: 0,
          loading: false,
          data: []
        },
        addModal: {
          display: false,
          name: "",
          phone: "",
          email: "",
          sex: "",
          remark: "",
          mainChannel: "",
          parentChannel: "",
          childChannel: "",
          rules: {
            name: [{
              required: true,
              message: "名字不能为空",
              trigger: "blur"
            }],
            phone: [{
                required: true,
                message: "手机号不能为空",
                trigger: "blur"
              },
              {
                pattern: phoneRegular,
                message: "请输入正确的手机号",
                trigger: "blur"
              }
            ],
            email: [{
                required: true,
                message: "邮箱不能为空",
                trigger: "blur"
              },
              {
                pattern: emailRegular,
                message: "请输入正确的邮箱",
                trigger: "blur"
              }
            ],
            mainChannel: [{
              required: true,
              message: "请选择主渠道",
              trigger: "change"
            }],
            remark: [{
                required: false,
                trigger: "blur"
              },
              {
                type: 'string',
                max: 255,
                message: '备注不能超过255字'
              }
            ]
          }
        },
        editModal: {
          display: false,
          id: "",
          name: "",
          email: "",
          remark: "",
          rules: {
            name: [{
              required: true,
              message: "名字不能为空",
              trigger: "blur"
            }],
            email: [{
                required: true,
                message: "邮箱不能为空",
                trigger: "blur"
              },
              {
                pattern: emailRegular,
                message: "请输入正确的邮箱",
                trigger: "blur"
              }
            ],
            remark: [{
                required: false,
                trigger: "blur"
              },
              {
                type: 'string',
                max: 255,
                message: '备注不能超过255字'
              }
            ]
          }
        },
        editStatusModal: {
          display: false,
          id: '',
          name: '',
          status: 1
        },
        // 表格信息
        columnsInfo: [{
            title: "ID",
            key: "userId",
            align: "center",
            width: 100
          },
          {
            title: "姓名",
            key: "realname",
            align: "center",
            width: 140,
            render: (h, params) => {
              return h(
                "a", {
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.checkHasPermissionForDetail(params.row.userId)
                    }
                  }
                },
                params.row.name
              )
            }
          },
          {
            title: "手机号",
            key: "phone",
            align: "center",
            width: 140
          },
          {
            title: "open_id",
            key: "openId",
            align: "center",
            width: 110
          },
          {
            title: "状态",
            key: "userStat",
            align: "center",
            width: 90,
            render: (h, params) => {
              const stateText = ["", "正常", "锁定", "黑名单"][
                params.row.userStat
              ];
              return h("div", {}, stateText);
            }
          },
          {
            title: "用户来源",
            key: "sourceName",
            align: "center",
            width: 100
          },
          {
            title: "身份审核状态",
            key: "state",
            align: "center",
            width: 150,
            render: (h, params) => {
              let stateText = ''
              if (params.row.infoState !== null) {
                stateText = ["未验证", "待审核", "已验证", "审核不通过", "待完成"][params.row.infoState];
              }
              
              return h("div", {}, stateText);
            }
          },
          {
            title: "创建时间",
            align: "center",
            width: 200,
            key: "createdAt",
            render: (h, param) =>
              h("span", moment(param.row.createdAt).format("YYYY-MM-DD HH:mm:ss"))
          },
          {
            title: "更新时间",
            align: "center",
            width: 200,
            key: "updatedAt",
            render: (h, param) =>
              h("span", moment(param.row.updatedAt).format("YYYY-MM-DD HH:mm:ss"))
          },
          {
            title: "操作",
            key: "action",
            width: 250,
            align: "center",
            render: (h,params) => {
              return h("div", [
                h(
                  "Button", {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.checkHasPermissionForDetail(params.row.userId)
                      }
                    }
                  },
                  "详情"
                ),
                h(
                  "Button", {
                    props: {
                      type: "warning",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.openEditModal(params.row)
                      }
                    }
                  },
                  "修改"
                ),

                h(
                  "Button", {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.openEditStatusModal(params.row)
                      }
                    }
                  },
                  "修改状态"
                ),
                // h(
                //   "Button", {
                //     props: {
                //       type: "info",
                //       size: "small"
                //     },
                //     style: {
                //       marginRight: "5px",
                //       display: params.row.state === 1 ? 'inline-block' : 'none'
                //     },
                //     on: {
                //       click: () => {
                //         this.show();
                //       }
                //     }
                //   },
                //   "审核身份"
                // )
              ]);
            }
          }
        ]
      };
    },
    methods: {
      changePage(page) {
        this.vipList.page = page;
        this.queryVipList();
      },
      changePageSize(pageSize) {
        this.vipList.pageSize = pageSize;
        this.queryVipList();
      },
      queryVipListByKeyword() {
        this.vipList.page = 1;
        this.queryVipList();
      },
      async queryVipList() {
        // 会员列表接口
        this.vipList.loading = true;

        const params = {
          page: this.vipList.page,
          rows: this.vipList.pageSize,
          filter: {}
        }

        this.searchForm.review !== 'S00' && (params.filter.state = this.searchForm.review)
        this.searchForm.source !== 'S00' && (params.filter.source = this.searchForm.source)
        this.searchForm.name.length > 0 && (params.filter.name = this.searchForm.name)
        this.searchForm.phone.length > 0 && (params.filter.phone = this.searchForm.phone)

        // 接口接收此空对象，会异常
        if (Object.keys(params.filter).length === 0) {
          delete params.filter
        }

        const allUserList = (await API.omsAPI[this.env].php.queryAllUsers(params)).data;
        this.vipList.loading = false;
        if (allUserList.retcode) {
          this.$Notice.error({
            title: "查询会员列表失败"
          });
          return;
        }
        this.vipList.data = allUserList.content;
        this.vipList.count = allUserList.total;
      },
      // 点击新增按钮并初始化
      displayAddModal() {
        this.addModal = Object.assign({}, this.addModal, {
          display: true,
          name: '',
          phone: '',
          email: '',
          sex: 1,
          remark: '',
          mainChannel: Object.keys(this.usersSources)[0] || '',
          parentChannel: '',
          childChannel: ''
        })
      },
      async preAddVip() {
        let validResult = false
        this.$refs.addForm.validate(valid => {
          validResult = valid
        });
        if (!validResult) {
          this.$refs.addModal.buttonLoading = false;
          return;
        }

        const params = {
          realname: this.addModal.name,
          phone: this.addModal.phone,
          sex: this.addModal.sex,
          email: this.addModal.email,
          mainSource: this.addModal.mainChannel,
          nodeSource: this.addModal.parentChannel,
          source: this.addModal.childChannel,
          remark: this.addModal.remark
        }

        params.selectedSource = params.source;
        if( params.source === null || params.source === undefined ) {
          params.selectedSource = params.nodeSource;
        }
        if( params.nodeSource === null || params.nodeSource === undefined ) {
          params.selectedSource = params.mainSource;
        }

        let addUserResp = (await API.omsAPI[this.env].php.addUser(params)).data;

        // 判断是否有新增会员权限
        if (addUserResp.retcode === -999) {
          this.$Notice.error({
            title: '您没有权限新增会员'
          });
          return
        }

        addUserResp = addUserResp.retdata
        if (addUserResp.retCode) {
          this.$Notice.error({
            title: addUserResp.msg
          });
          this.$refs.addModal.buttonLoading = false;
          return;
        }
        this.addModal.display = false;

        this.queryVipListByKeyword()
      },
      openEditModal(userInfo) {
        this.editModal = Object.assign({}, this.editModal, {
          display: true,
          id:  userInfo.userId,
          name: userInfo.realname,
          email: userInfo.email,
          remark: userInfo.remark
        })
      },
      async preEditVip() {
        let validResult = false
        this.$refs.editForm.validate(valid => {
          validResult = valid
        });
        if (!validResult) {
          this.$refs.editModal.buttonLoading = false;
          return;
        }

        const params = {
          userId: this.editModal.id,
          realname: this.editModal.name,
          email: this.editModal.email,
          remark: this.editModal.remark
        }

        let editUserResp = (await API.omsAPI[this.env].php.editUser(params)).data;

        // 判断是否有新增会员权限
        if (editUserResp.retcode === -999) {
          this.$Notice.error({
            title: '您没有权限编辑'
          });
          return
        }

        editUserResp = editUserResp.retdata
        if (editUserResp.retCode) {
          this.$Notice.error({
            title: editUserResp.msg
          });
          this.$refs.editModal.buttonLoading = false;
          return;
        }
        this.editModal.display = false;

        this.queryVipListByKeyword()
      },
      openEditStatusModal(userInfo) {
        this.editStatusModal = Object.assign({}, this.editStatusModal, {
          display: true,
          id:  userInfo.userId,
          name: userInfo.realname,
          status: userInfo.userStat
        })
      },
      async preEditStatusVip() {
        const params = {
          userId: this.editStatusModal.id,
          userStat: this.editStatusModal.status
        }

        let editStatusUserResp = (await API.omsAPI[this.env].php.editUserState(params)).data;

        // 判断是否有新增会员权限
        if (editStatusUserResp.retcode === -999) {
          this.$Notice.error({
            title: '您没有权限编辑状态'
          });
          return
        }

        editStatusUserResp = editStatusUserResp.retdata
        if (editStatusUserResp.retCode) {
          this.$Notice.error({
            title: editStatusUserResp.msg
          });
          this.$refs.editStatusModal.buttonLoading = false;
          return;
        }
        this.editStatusModal.display = false;

        this.queryVipListByKeyword()
      },
      // 判断是否有权限进入会员管理详情
      checkHasPermissionForDetail(userId) {
        if(!Utils.hasPermission('oms_userInfo_memberDetailView')){
          this.$Notice.error({
            title: Utils.getFromStore(STORE_KEY.STORE_KEY_NOT_PERMISSION_TIPS)
          });

          return;
        }

        if(this.$router){
          this.$router.push({path: "/app/Vip/vipDetail", query: { userId }});
        }else{
          window.open(`#/Order/Reserve/memberDetailView?userId=${userId}`);
        }
      }
    }
  };

</script>
<style lang="scss" scoped>
  .inquire {
    margin-top: 20px;
  }

  .formWidth {
    width: 148px;
  }

  .pages {
    margin-top: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/vip/management-list.vue